export const LightType = {
    spotLight: "spotLight",
    pointLight: "pointLight",
    directionalLight: "directionalLight",
    // Globale Lichter (Jans Editor): ohne Position/Schatten — der Port kannte
    // sie nicht, updateLight konnte sie deshalb nie konstruieren.
    ambientLight: "ambientLight",
    hemisphereLight: "hemisphereLight",
} as const;
export type LightType = (typeof LightType)[keyof typeof LightType];
